import {
  SET_SHOW_PRODUCT_STATUS_MODAL,
  SET_SINGLE_PRODUCT_DELETE_ROW_ID,
  SET_SINGLE_PRODUCT_IMAGE_UPLOAD_ROW_ID,
  SET_PRODUCT_LIST_ACTIVE_TAB,
  SET_PRODUCTS_LOADING,
  SET_PRODUCTS_DATA,
  SET_PRODUCTS_ERROR,
  SET_IS_PRICE_AREA_UPDATE,
  SET_ACTIVE_INPUT_ID,
  SET_IS_PRICE_AREA_STATUS,
  SET_IS_PRICE_AREA_ERROR_MESSAGE,
  SET_SUB_TABS_BY_KEY
} from "./mutation-types";

export default {
  // Product modal mutations
  [SET_SHOW_PRODUCT_STATUS_MODAL](state, payload) {
    state.showProductStatusModal = payload;
  },

  // Product row ID mutations
  [SET_SINGLE_PRODUCT_DELETE_ROW_ID](state, payload) {
    state.singleProductDeleteRowId = payload;
  },

  [SET_SINGLE_PRODUCT_IMAGE_UPLOAD_ROW_ID](state, payload) {
    state.singleProductImageUploadRowId = payload;
  },

  // Product list mutations
  [SET_PRODUCT_LIST_ACTIVE_TAB](state, payload) {
    state.productListActiveTab = payload;
  },

  // Product data mutations
  [SET_PRODUCTS_LOADING](state, { operation, isLoading }) {
    state.isLoading[operation] = isLoading;
  },

  [SET_PRODUCTS_DATA](state, payload) {
    state.productsData = payload;
  },

  [SET_PRODUCTS_ERROR](state, { operation, error }) {
    state.errors[operation] = error;
  },

  // Product update mutations
  [SET_IS_PRICE_AREA_UPDATE](state, payload) {
    state.isPriceAreaUpdate = payload;
  },

  [SET_IS_PRICE_AREA_STATUS](state, payload) {
    state.isPriceAreaStatus = payload;
  },

  [SET_IS_PRICE_AREA_ERROR_MESSAGE](state, payload) {
    state.isPriceAreaErrorMessage = payload;
  },

  [SET_ACTIVE_INPUT_ID](state, id) {
    state.activePopoverId = id;
  },

  [SET_SUB_TABS_BY_KEY](state, { key, subTabs }) {
    state.subTabsByKey[key] = subTabs;
  },
};
